import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { media } from '@mlb/react-patterns/style/helpers/media.ts';
import SkeletonPattern from '@mlb/react-patterns/components/Skeleton/skeleton.tsx';
import COLORS from '@mlb/react-patterns/style/universal.color';
import FONTS from '@mlb/react-patterns/style/fonts.ts';

export const StyledHeading = styled.h1`
    font-family: ${FONTS.primaryFont};
    color: ${COLORS.mlbWhite};
    font-weight: bold;
    height: 36px;
    font-size: 22px;
    margin-bottom: 0;
    line-height: 36px;
    white-space: nowrap;

    ${media.smmin`
        font-size: 25px;
    `}
`;

const Skeleton = styled(SkeletonPattern)`
    max-width: 200px;

    ${media.mdmin`
        width: 200px;
    `}
`;

const Heading = ({
    children,
    isLoading,
}) => {

    return isLoading ? (
        <Skeleton
            isLoading={isLoading}
            width={'100%'}
            height={'30px'}
        />
    ) : (
        <StyledHeading>{children}</StyledHeading>
    );

};

Heading.propTypes = {
    children: PropTypes.node.isRequired,
    isLoading: PropTypes.bool,
};

Heading.defaultProps = {
    isLoading: false,
};

export default Heading;
